import { BILLING } from 'utils/reducers';

const initialState = {
    show: false,
};

const showBillingReducer = (state = initialState, action) => {
    switch (action.type) {
        case BILLING.display:
            return { ...state, show: true };
        case BILLING.hide:
            return { ...state, show: false };
        default:
            return state;
    }
};

export default showBillingReducer;
